import { generateMedia } from 'styled-media-query';

import { breakpoints as breakpointsCore } from '@basfagro/core';

const breakpoints = generateMedia(breakpointsCore);

export default breakpoints;
